import { AnyAction } from 'redux'
import { Actions } from '../actions/activities'
import { ActivitiesState } from '../states/activitiesState'

export const ACTIVITIES_REDUCER_NAMESPACE = 'activitiesReducer'

const defaultState: ActivitiesState = {
    activities: [],
    loading: true,
    filters: {
        page: 1,
        page_size: 5,
        tab: 'to_me',
    },
    activePage: 0,
    totalPages: 3,
    showContent: true,
    hideSidebar: false,
}

export default (state: ActivitiesState = defaultState, action: AnyAction) => {
    switch (action.type) {
        case Actions.GET_ACTIVITIES_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case Actions.GET_ACTIVITIES_SUCCESS:
            return {
                ...state,
                activities: action.activities,
                loading: false,
            }
        case Actions.GET_ACTIVITIES_FAILURE:
            return {
                ...state,
                loading: false,
            }
        case Actions.SET_ACTIVE_PAGE:
            return {
                ...state,
                activePage: action.activePage,
            }
        case Actions.SET_SHOW_CONTENT:
            return {
                ...state,
                showContent: action.showContent,
            }
        case Actions.SET_HIDE_SIDEBAR:
            return {
                ...state,
                hideSidebar: action.hideSidebar,
            }
        default:
            return state
    }
}
